import { Component, OnInit, ElementRef, HostListener, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { ChartDataSets, ChartOptions, ChartType } from "chart.js";
import { Label } from "ng2-charts";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { AuthenticationService } from "@app/_services";

import { Totals } from "@app/_models";
import { Accounts } from "@app/_models";
import { Kpi } from "@app/_models";
import { Conclusions } from "@app/_models";
import { TextSlides } from "@app/_models";
import { catchError, map } from "rxjs/operators";
import { AppComponent } from "@app/app.component";
import { TranslateService } from "@ngx-translate/core";
import { ApiBackendService } from "@app/_services/api-backend.service";
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: "app-file",
  templateUrl: "file.component.html",
  styleUrls: ["file.component.css"],
})
export class FileComponent implements OnInit {
  apiUrl = null;
  totals: Observable<Totals[]>;
  accounts: Observable<Accounts[]>;
  kpis: Observable<Kpi[]>;
  conclusions: Observable<Conclusions[]>;
  slides: Observable<TextSlides[]>;
  public account: any = [];
  public total: any = [];
  public kpi: any = [];
  public allKpi: any = [];
  public conclusion: any = [];
  public textSlides: any = [];
  loadingAccounts = true;
  loadingTotals = true;
  loadingKpi = true;
  loadingConclusions = true;
  loadingSlides = true;
  loadingExport = true;
  loadingDownload = false;
  loadingDiagnostic = false;
  bodyContent: String;
  expandSet = new Set<number>();
  expandedTables = new Set<string>();
  chartsData: any = [];
  chartsDataConclusion: any = [];
  chartsData2: any = [];
  chartsLabels: any = [];
  columnNames: any = [];
  columnNames2: any = [];
  chartConclusionsColNames: any = [];
  userRole = null;
  fileMonthNumeric: Number;
  fileMonthYear: String;
  fileMonth: String;
  fileYear: String;
  isLanguageSelectorVisible = true;
  venituri21 = 0;
  profit21 = 0;

  counter: number;
  length: number;
  pdf: jsPDF;

  sysLanguage = "ro";

  allPanelsExpanded: boolean = false;
  kpiPanelExpanded: boolean = false;
  isMobile: boolean = false;
  today = new Date();
  // Email functionality
  showEmailForm: boolean = false;
  recipientEmail: string = '';
  sendingEmail: boolean = false;

  // Notes functionality
  showNotesForm: boolean = false;
  fileNotes: string = '';
  savingNotes: boolean = false;
  currentFileId: string = '';


  public typeChart = {
    bar: "ColumnChart",
    stackedBar: "ColumnChart",
    pie: "PieChart",
  };

  public optionsChart = {
    colors: ["#28B5B5", "#8FD9A8", "#D2E69C", "#C996CC", "#916BBF", "#4B778D", "#3D2C8D", "#1C0C5B"],
    // hAxis: {
    //   title: 'Valori'
    // },
    // vAxis:{
    //   format: '#%',
    //   viewWindow: {
    //     max:1.0,
    //     min:0.2
    //   }
    // },
    isStacked: true,
    is3D: true,
    legend: "none",
    fontSize: 14,
    fontName: "Gothic",
    role: "annotation",
  };

  public widthChart = 600;
  public heightChart = 600;
  //   public data = [
  //     ["2012", 900, 390],
  //     ["2013", -1000, 400],
  //     ["2014", 1170, 440],
  //     ["2015", 1250, 480],
  //     ["2016", 1530, 540]
  //  ];
  //  public columnNames = ['Browser', 'Valori'];
  //  public columnNames: any[] = [];

  public chartStockLabels: Label[] = [];
  public chartStockType: ChartType = "pie";
  public chartStockLegend = false;
  public chartStockData: ChartDataSets[] = [{ data: [] }];

  proceduresTextList: string[] = [
    "un profit net",
    "o pierdere neta",
    "Profitul financiar",
    "Pierderea financiara",
    "Profitul",
    "Pierderea",
    "Cheltuiala cu dobanzile",
    "De asemenea, ai o productie in curs de executie in valoare de",
    "Te rog sa verifici cu contabilul tau cat de veche este productia in curs si sa iti propui sa o valorifici cat mai repede, pentru a debloca banii imobilizati in aceasta.",
    "si cu comisioanele bancare",
    "reprezinta",
    "din creditele pe care le ai la banci sau la companiile de leasing, finantari in valoare de",
  ];

  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private app: AppComponent,
    private translate: TranslateService,
    private apiBackend: ApiBackendService,
    private message: NzMessageService
  ) {

    // redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      this.router.navigate(["/login"]);
    }
    this.userRole = this.authenticationService.currentUserInfo.role;
    // else if(this.authenticationService.currentUserInfo.role != 'admin')
    // {
    //   this.router.navigate(['/']);
    // }
    this.apiUrl = this.authenticationService.apiUrl;
    this.fileMonthYear = localStorage.getItem("fileMonthYear");
    this.fileMonth = localStorage.getItem("fileMonth");
    this.fileYear = localStorage.getItem("fileYear");
    this.fileMonthNumeric = Number(localStorage.getItem("fileMonthNumeric"));
  }

  getTotals() {
    let processID = this.activatedRoute.snapshot.params.id;
    return this.http.get<Totals[]>(this.apiUrl + "/bp_totals/" + processID, {
      observe: "response",
    });
  }

  getAccounts() {
    let processID = this.activatedRoute.snapshot.params.id;
    return this.http.get<Accounts[]>(this.apiUrl + "/bp_accounts/" + processID, {
      observe: "response",
    });
  }

  getKpis() {
    let processID = this.activatedRoute.snapshot.params.id;
    return this.http.get<Kpi[]>(this.apiUrl + "/bp_kpi/" + processID, {
      observe: "response",
    });
  }

  getAllKpis() {
    return this.http.get<Kpi[]>(this.apiUrl + "/kpi", {
      observe: "response",
    });
  }

  getConclusions() {
    let processID = this.activatedRoute.snapshot.params.id;
    return this.http.get<Conclusions[]>(this.apiUrl + "/bp_conclusions/" + processID, {
      observe: "response",
    });
  }

  getTextSlides(language: string) {
    let processID = this.activatedRoute.snapshot.params.id;
    return this.http.get<TextSlides[]>(`${this.apiUrl}/text_slides/${processID}?lang=${language}`, {
      observe: "response",
    });
  }

  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  isTableExpanded(tableId: string): boolean {
    return this.expandedTables.has(tableId);
  }

  toggleAllTotalsExpand(totals: any[], tableId: string = 'default'): void {
    const expanding = !this.expandedTables.has(tableId);
    if (expanding) {
      this.expandedTables.add(tableId);
      for (const row of totals) {
        if (this.isNum(row.accountTypeId)) {
          this.expandSet.add(row.id);
        }
        if (row.group) {
          for (const group of row.group) {
            if (this.isNum(group.accountTypeId)) {
              this.expandSet.add(group.id);
            }
          }
        }
      }
    } else {
      this.expandedTables.delete(tableId);
      for (const row of totals) {
        this.expandSet.delete(row.id);
        if (row.group) {
          for (const group of row.group) {
            this.expandSet.delete(group.id);
          }
        }
      }
    }
  }

  isNum(value) {
    if (Number(value)) {
      return true;
    }
    return false;
  }

  ngOnInit() {
    this.app.switchLanguage(this.sysLanguage);
    this.route.params.subscribe((params) => {
      const language = params["language"];
      if (language === "en") {
        this.sysLanguage = language;
        this.app.switchLanguage(this.sysLanguage);
      }
    });
    this.checkIfMobile();
    window.addEventListener('resize', () => this.checkIfMobile());


    window.scrollTo(0, 0);

    console.log("init");
    const processId = this.route.snapshot.paramMap.get("id");
    console.log("File component - processId (from URL):", processId, "fileId (from localStorage):", localStorage.getItem("fileId"));

    // Load file notes using the file ID from localStorage
    this.loadFileNotes();

    this.apiBackend.getFileDiag(processId, this.sysLanguage).subscribe((response: any) => {
      this.loadingDiagnostic = true;
      this.bodyContent = response.body.content;
      console.log(response);
    });
    this.getTotals()
      .pipe()
      .subscribe(
        (res) => {
          this.total = res.body;

          // for (let t of this.total) {
          //   if (t.t1 != null) {
          //     // console.log(t.t1);
          //   }
          // }
          this.loadingTotals = false;
        },
        (err) => {
          this.router.navigate(["/files"]);
        }
      );

    this.getAccounts()
      .pipe()
      .subscribe(
        (res) => {
          this.account = res.body;
          this.loadingAccounts = false;
        },
        (err) => { }
      );

    this.getKpis()
      .pipe()
      .subscribe(
        (res) => {
          this.kpi = res.body;
          this.loadingKpi = false;
        },
        (err) => { }
      );

    this.getAllKpis()
      .pipe()
      .subscribe(
        (res) => {
          this.allKpi = res.body;
        },
        (err) => { }
      );

    this.getConclusions()
      .pipe()
      .subscribe(
        (res) => {
          this.conclusion = res.body;
          this.loadingConclusions = false;
        },
        (err) => { }
      );

    this.getTextSlides(this.sysLanguage)
      .pipe()
      .subscribe(
        (res) => {
          this.textSlides = res.body;
          this.loadingSlides = false;
          this.loadingExport = false;

          let tempValues = [];

          for (let val of this.textSlides) {
            if (val.chartType == "bar") {
              let tempDataAccounts: any[] = [];
              let tempDataAccounts2: any[] = [];
              let tempColumnsNames: any[] = [""];
              let tempColumnsNames2: any[] = [""];
              let tempLabels = [];

              let itemCounts = val.accounts.length;
              let itemCounts2 = val.accounts2.length;
              for (let idAcc of Object.keys(val.accounts)) {
                let acc = val.accounts[idAcc];
                if (acc != null) {
                  tempColumnsNames = ["", "Valoare", { role: "style" }];
                  tempDataAccounts.push([acc.acc.value, this.optionsChart.colors[idAcc]]);
                  // let tempList = [acc.account_description];
                  // for (let i = 0; i < itemCounts; i++) {
                  //   if (Number(i) == Number(idAcc)) {
                  //     tempList.push(acc.value);
                  //   } else {
                  //     tempList.push(0);
                  //   }
                  // }

                  // tempDataAccounts.push(tempList);
                }
              }

              for (let idAcc2 of Object.keys(val.accounts2)) {
                let acc2 = val.accounts2[idAcc2];
                if (acc2 != null) {
                  tempColumnsNames2 = ["", "Valoare", { role: "style" }];
                  tempDataAccounts2.push([acc2.account_description, acc2.value, this.optionsChart.colors[idAcc2]]);
                  // tempColumnsNames2.push(acc2.account_description);
                  // let tempList2 = [acc2.account_description];
                  // for (let i = 0; i < itemCounts2; i++) {
                  //   if (Number(i) == Number(idAcc2)) {
                  //     tempList2.push(acc2.value);
                  //   } else {
                  //     tempList2.push(0);
                  //   }
                  // }

                  // tempDataAccounts2.push(tempList2);
                }
              }

              let i = 0;
              for (let conclusion of this.conclusion) {
                let acc = val.tableName;
                if (acc != null && conclusion[acc] != null) {
                  if (acc == "VenituriCheltuieli1") {
                    this.venituri21 = conclusion[acc][0][1];
                    this.profit21 = conclusion[acc][1][1];
                    console.log('venituri21:', this.venituri21); // Check assigned values
                    console.log('profit21:', this.profit21);

                  }
                  for (let concValue of conclusion[acc]) {
                    if (concValue[concValue.length - 1] != null) {
                      tempDataAccounts.push([concValue[concValue.length - 2], concValue[concValue.length - 1], this.optionsChart.colors[i]]);
                      tempColumnsNames = ["", "Valoare", { role: "style" }];
                      i++;
                    }
                  }
                }
              }

              this.columnNames[val.id] = tempColumnsNames;
              this.columnNames2[val.id] = tempColumnsNames2;
              this.chartsData[val.id] = tempDataAccounts;
              this.chartsData2[val.id] = tempDataAccounts2;
              this.chartsLabels[val.id] = tempLabels;
              // this.chartsDataConclusion[val.id] = [tempConclusions];
              // this.chartConclusionsColNames[val.id] = tempConclusionsColNames;
            } else if (val.chartType == "pie") {
              let tempDataAccounts: any[] = [];
              let tempDataAccounts2: any[] = [];
              let tempColumnsNames: any[] = [""];
              let tempColumnsNames2: any[] = [""];
              let tempConclusionsColNames: any[] = [""];
              let tempLabels = [];
              let tempConclusions = [];

              tempColumnsNames.push("Valoare");
              tempColumnsNames2.push("Valoare");
              for (let account of Object.keys(val.accounts)) {
                let acc = val.accounts[account];
                if (acc != null && acc.value >= 0) {
                  tempDataAccounts.push([this.translate.instant(acc.account_description), acc.value]);
                }
              }

              for (let account2 of Object.keys(val.accounts2)) {
                let acc2 = val.accounts2[account2];
                if (acc2 != null && acc2.value >= 0) {
                  tempDataAccounts2.push([this.translate.instant(acc2.account_description), acc2.value]);
                }
              }

              for (let conclusion of this.conclusion) {
                let acc = val.tableName;
                if (acc != null && conclusion[acc] != null) {
                  for (let concValue of conclusion[acc]) {
                    tempConclusions.push([concValue[0], concValue[1]]);
                  }
                }
              }

              this.columnNames[val.id] = tempColumnsNames;
              this.columnNames2[val.id] = tempColumnsNames2;
              this.chartsData[val.id] = tempDataAccounts;
              this.chartsData2[val.id] = tempDataAccounts2;
              this.chartsLabels[val.id] = tempLabels;
              this.chartsDataConclusion[val.id] = tempConclusions;
            } else if (val.chartType == "stackedBar") {
              let tempDataAccounts: any[] = [];
              let tempDataAccounts2: any[] = [];
              let tempColumnsNames: any[] = [""];
              let tempColumnsNames2: any[] = [""];
              let tempConclusionsColNames: any[] = [""];
              let tempLabels = [];
              let tempConclusions = [];

              tempDataAccounts.push("");
              for (let account of Object.keys(val.accounts)) {
                let acc = val.accounts[account];
                if (acc != null) {
                  tempDataAccounts.push(acc.value);
                  tempColumnsNames.push(this.translate.instant(acc.account_description));
                }
              }
              this.columnNames[val.id] = tempColumnsNames;
              this.chartsData[val.id] = [tempDataAccounts];

              tempDataAccounts2.push("");
              for (let account2 of Object.keys(val.accounts2)) {
                let acc2 = val.accounts2[account2];
                if (acc2 != null) {
                  tempDataAccounts2.push(acc2.value);
                  tempColumnsNames2.push(this.translate.instant(acc2.account_description));
                }
              }
              this.columnNames2[val.id] = tempColumnsNames2;
              this.chartsData2[val.id] = [tempDataAccounts2];
            } else {
            }
          }
        },
        (err) => { }
      );
  }

  ngOnDestroy() {
    this.columnNames;
    this.columnNames2;
    this.chartsData;
    this.chartsData2;
    this.chartsLabels;
    this.textSlides;
    this.total;
    this.account;
    this.kpi;
    this.columnNames;
    this.allKpi;
    this.conclusion;
  }

  public convert(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  public convertWithToday(value) {
    const lastDayOfMonth = new Date(Number(this.fileYear), Number(this.fileMonthNumeric), 0);
    const dateString = lastDayOfMonth.getDate() + ' ' + this.fileMonth + ' ' + this.fileYear;


    // Find the last </p> tag and insert the date before it
    const lastPIndex = value.lastIndexOf('</p>');

    if (lastPIndex !== -1) {
      const enrichedValue = value.substring(0, lastPIndex) + ' ' + dateString + value.substring(lastPIndex);
      return this.sanitizer.bypassSecurityTrustHtml(enrichedValue);
    } else {
      // If no </p> tag found, just append the date
      return this.sanitizer.bypassSecurityTrustHtml(value + ' ' + dateString);
    }
  }

  public convertAndTranslate(value: string | null | undefined): SafeHtml {
    // Guard against null or undefined value
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    // Guard against null or undefined proceduresTextList
    if (!this.proceduresTextList || this.proceduresTextList.length === 0) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }

    this.proceduresTextList.forEach((text) => {
      // Guard against null or undefined text items
      if (!text) {
        return; // Skip this iteration
      }

      this.translate.get(text).subscribe((translated: string) => {
        if (translated) {
          value = value.replace(text, translated);
        }
      });
    });

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  // public convertAndTranslate(value: string): SafeHtml {
  //   this.proceduresTextList.forEach((text) => {
  //     this.translate.get(text).subscribe((translated: string) => {
  //       value = value.replace(text, translated);
  //     });
  //   });
  //
  //   return this.sanitizer.bypassSecurityTrustHtml(value);
  // }

  // public expandNotes() {
  //   alert('expand');
  // }

  public notesConvert(value, id) {
    let countStrings = value.split(" ").length;

    // if(countStrings > 50)
    // {
    //   value = '<div class="readmore"><div class="readmore-container">' + value + '</div><button id="readmore-btn-' + id + '" class="readmore-btn" (click)="expandNotes()">Citeste mai mult</button></div>';
    // }

    // document.getElementById('readmore-btn-' + id).addEventListener('click', event => {
    //   alert('expand');
    // })

    let strings = this.sanitizer.bypassSecurityTrustHtml(value);
    return strings;
  }

  // public htmltoPDF() {
  //   this.loadingDownload = true;
  //   // console.log('click');
  //   // printDiv is the html element which has to be converted to PDF
  //   html2canvas(document.querySelector('body')).then((canvas) => {
  //     // var pdfFile = new jsPDF('p', 'pt', [297, 210]);
  //     var pdfFile = new jsPDF('p', 'pt', [canvas.width, canvas.height]);
  //     var pdfWidth = pdfFile.internal.pageSize.getWidth();
  //     var pdfHeight = pdfFile.internal.pageSize.getHeight();

  //     console.log(pdfWidth, pdfHeight);

  //     var imgWidth = (canvas.width * 50) / pdfWidth;
  //     var imgHeight = (canvas.height * 20) / pdfHeight;

  //     var imgData = canvas.toDataURL('image/jpeg', 0.8);
  //     // pdfFile.addImage(imgData, 'png', 10, 0, 50, 50);
  //     pdfFile.addImage(imgData,0,0,canvas.width, canvas.height);
  //     // pdfFile.addImage(imgData,0,0,imgWidth, imgHeight);
  //     pdfFile.save('previewPDF-doctorbusiness.pdf');

  //     this.loadingDownload = false;
  //   });
  // }

  public htmltoPDF() {
    this.loadingDownload = true;
    this.pdf = new jsPDF("p", "mm", "a4");
    this.length = this.textSlides.length;
    // this.length = 3
    this.counter = 0;

    this.generatePDF();
  }

  generatePDF() {
    let data = document.getElementById("slide_" + this.counter);

    html2canvas(data, {
      // scale: 3
    }).then((canvas) => {
      this.counter++;

      var imgWidth = 208;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;

      console.log(data);

      const contentDataURL = canvas.toDataURL("image/png");
      var position = 0;
      this.pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);

      if (this.counter < this.length) {
        console.log("addPage");
        this.pdf.addPage();
        this.generatePDF();
      } else {
        console.log("save");
        this.loadingDownload = false;
        this.pdf.save("test.pdf");
        return true;
      }
    });
  }

  public htmltohtml() {
    console.log(this.el.nativeElement.querySelector("#topHead").outerHTML.replace(/<!--[\s\S]*?-->/g, ""));
  }

  // public dataChart(data) {
  //   let tempData = [];
  //   for (let value of data)
  //   {
  //     tempData.push([value.account_description, value.value]);
  //   }
  //   return tempData;
  // }

  goToAnchor(id) {
    document.querySelector("#" + id).scrollIntoView();
    // this.router.navigate(['/file/' + this.activatedRoute.snapshot.params.id], { fragment: id });
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event: any) {
    // let selection = this.chart.wrapper.visualization.getSelection();
    // this.chart.redraw();
    // this.chart.wrapper.visualization.setSelection(selection);
    // you can remove two lines that preserve selection if you don't need them
  }
  public switchLanguage(language: string) {
    this.app.switchLanguage(language);
    this.sysLanguage = language;
    this.resetData();
    this.ngOnInit();
  }
  printReport() {
    this.isLanguageSelectorVisible = false;
    setTimeout(() => {
      window.print();
      this.isLanguageSelectorVisible = true;
    }, 0);
  }
  resetData(): void {
    this.loadingAccounts = true;
    this.loadingTotals = true;
    this.loadingKpi = true;
    this.loadingConclusions = true;
    this.loadingSlides = true;
    this.loadingExport = true;
    this.loadingDiagnostic = false;
  }
  openDiagnostic() {
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.router.navigate(["/diagnostic/" + id]);
    } else {
      console.error("ID-ul nu a fost găsit în URL");
    }
  }

  toggleAllPanels(): void {
    this.allPanelsExpanded = !this.allPanelsExpanded;
  }

  get collapsibleSlides() {
    return this.textSlides.filter(slide =>
      slide.slideClass === 'tableChart' &&
      [1, 2, 3, 4, 5, 6, 7].includes(slide.id)
    );
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 992;
  }
  /**
   * Toggle afișare formular email
   */
  toggleEmailForm(): void {
    this.showEmailForm = !this.showEmailForm;
    if (!this.showEmailForm) {
      this.recipientEmail = '';
    }
  }

  /**
   * Validare adresă email
   */
  isValidEmail(email: string): boolean {
    if (!email) return false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
  }

  /**
   * Trimite raportul pe email
   */
  async sendReportByEmail(): Promise<void> {
    if (!this.isValidEmail(this.recipientEmail)) {
      this.message.error('Adresa de email nu este validă');
      return;
    }

    this.sendingEmail = true;
    const logoUrl = `${window.location.origin}/assets/img/db_pdf_logo.jpg`;

    // Salvează starea curentă a panourilor
    const previousAllPanelsExpanded = this.allPanelsExpanded;
    const previousKpiPanelExpanded = this.kpiPanelExpanded;

    try {
      // ============================================
      // 0. EXPANDEAZĂ TOATE PANOURILE PENTRU PDF
      // ============================================
      // Expandează capitolele 3.1-3.7
      this.allPanelsExpanded = true;
      // Expandează "Citeste mai multe despre: ce iti arata indicatorul..."
      this.kpiPanelExpanded = true;

      // Așteaptă ca Angular să actualizeze DOM-ul
      await new Promise(resolve => setTimeout(resolve, 500));

      // ============================================
      // 1. GĂSEȘTE SLIDE-URILE
      // ============================================
      const allSlides = document.querySelectorAll('[id^="slide_"]');

      if (allSlides.length === 0) {
        throw new Error('Nu s-au găsit slide-uri');
      }

      console.log(`Găsite ${allSlides.length} slide-uri`);

      // ============================================
      // 2. CREEAZĂ CONTAINER NOU CU LOGO FIXED PE FIECARE PAGINĂ
      // ============================================
      const slidesContainer = document.createElement('div');
      slidesContainer.className = 'pdf-slides-container';

      // ============================================
      // 2.0 LOGO REPEATING HEADER - VA APĂREA PE FIECARE PAGINĂ
      // Folosim table cu thead care se repetă pe fiecare pagină în PDF
      // ============================================
      const wrapperTable = document.createElement('table');
      wrapperTable.className = 'pdf-page-table';

      // THEAD - se va repeta pe fiecare pagină
      const thead = document.createElement('thead');
      thead.innerHTML = `
        <tr>
          <th class="pdf-repeating-header">
            <img src="${logoUrl}" alt="Doctor Business" class="pdf-header-logo">
          </th>
        </tr>
      `;
      wrapperTable.appendChild(thead);

      // TBODY - conținutul principal
      const tbody = document.createElement('tbody');
      const tbodyRow = document.createElement('tr');
      const tbodyCell = document.createElement('td');
      tbodyCell.className = 'pdf-content-cell';

      // ============================================
      // 2.1 CUPRINS (TABLE OF CONTENTS) - PRIMUL SLIDE
      // ============================================
      const infoColumnsElement = document.querySelector('.info-columns');
      if (infoColumnsElement) {
        const cuprinsWrapper = document.createElement('div');
        cuprinsWrapper.className = 'pdf-slide-wrapper';

        // Titlu cuprins - Decembrie 2025 + subtitle
        const cuprinsTitle = document.createElement('div');
        cuprinsTitle.innerHTML = `
          <h1 style="text-align: center; margin-top: 2rem; margin-bottom: 2rem; font-size: 42px;">
            <strong>${this.fileMonth} ${this.fileYear}</strong><br>
          </h1>
        `;
        cuprinsWrapper.appendChild(cuprinsTitle);

        // Cuprins - built with inline styles matching screenshot1.png exactly
        // Full colored border, circular badge overlapping left edge
        const chaptersData = [
          { num: '01', text: 'Analiza profitului de la venituri la rezultatul final (P&L)', color: '#1f92cc' },
          { num: '02', text: 'Diferența dintre PROFITul din balanță și CASH-ul din bancă', color: '#09c4a5' },
          { num: '03', text: 'Bilanțul - Averea Firmei și Sursele de Finanțare ale acesteia', color: '#ffb534' },
          { num: '04', text: 'Starea de Sănătate a Afacerii - KPI\'s - Indicatori Financiari de Performanță', color: '#ff594a' },
          { num: '05', text: 'Informatii utile', color: '#f553aa' },
          { num: '06', text: 'Obiceiuri de pus in practică în fiecare lună', color: '#5858bd' }
        ];

        let cuprinsHtml = '<div style="padding: 0 40px 0 60px;">';
        chaptersData.forEach(ch => {
          cuprinsHtml += `
            <div style="position: relative; margin-bottom: 1.2rem; margin-left: 25px;">
              <div style="position: absolute; left: -30px; top: 50%; transform: translateY(-50%); width: 55px; height: 55px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background-color: ${ch.color}; color: #fff; font-weight: 800; font-size: 28px; z-index: 1; box-shadow: 2px 2px 8px rgba(0,0,0,0.2);">${ch.num}</div>
              <div style="border: 3px solid ${ch.color}; border-radius: 8px; padding: 14px 15px 14px 40px; background: #fff; min-height: 45px; display: flex; align-items: center;">
                <p style="margin: 0; font-size: 22px; color: #333; font-weight: 700;">${ch.text}</p>
              </div>
            </div>
          `;
        });
        cuprinsHtml += '</div>';

        const cuprinsContent = document.createElement('div');
        cuprinsContent.innerHTML = cuprinsHtml;
        cuprinsWrapper.appendChild(cuprinsContent);

        tbodyCell.appendChild(cuprinsWrapper);
        console.log('Added cuprins slide with inline styles');
      } else {
        console.log('Warning: .info-columns not found, using hardcoded cuprins');
      }

      // Slide-uri care încep o secțiune nouă (vor avea page-break-before și logo)
      // Acestea corespund secțiunilor principale din raport (capitolele 1-6)
      const sectionStarts = new Set([
        // slide_0 este gol, cuprins-ul este acum creat din .info-columns mai sus
        'slide_1',   // 1. Ce vânzări ai avut și ce profit ai obținut
        'slide_11',  // 2. Diferenta dintre PROFIT și CASH
        'slide_13',  // 3. Bilanțul - Averea Firmei
        'slide_22',  // 4. Starea de Sănătate - KPI's
        'slide_24',  // 5. Informații utile
        'slide_30',  // 6. Obiceiuri de pus în practică
      ]);

      allSlides.forEach((slide, index) => {
        const slideId = slide.id; // Ex: "slide_0", "slide_1", etc.
        const slideElement = slide as HTMLElement;

        // Verifică dacă slide-ul are conținut vizibil (nu doar comentarii Angular)
        const textContent = slideElement.textContent?.trim() || '';
        const hasImages = slideElement.querySelectorAll('img').length > 0;
        const hasTables = slideElement.querySelectorAll('table').length > 0;

        // Skip slide-urile goale
        if (textContent.length < 10 && !hasImages && !hasTables) {
          console.log(`Skipping empty slide: ${slideId}`);
          return; // Skip this slide
        }

        const isSectionStart = sectionStarts.has(slideId);

        // Wrapper pentru fiecare slide
        const slideWrapper = document.createElement('div');

        // Adaugă clasa section-start pentru secțiunile principale (page-break înainte)
        // Cuprins-ul este deja adăugat ca primul slide, deci toate secțiunile pot avea page-break
        if (isSectionStart) {
          slideWrapper.className = 'pdf-slide-wrapper section-start';
        } else {
          slideWrapper.className = 'pdf-slide-wrapper';
        }

        // Logo-ul este acum fixed header (poziție fixă pe fiecare pagină)
        // Nu mai adăugăm logo individual pe fiecare slide

        // Conținutul slide-ului
        const slideContent = document.createElement('div');
        slideContent.className = 'pdf-slide-content';
        slideContent.innerHTML = slideElement.innerHTML;
        slideWrapper.appendChild(slideContent);

        tbodyCell.appendChild(slideWrapper);
      });

      // Asamblează structura tabelului pentru repeating header
      tbodyRow.appendChild(tbodyCell);
      tbody.appendChild(tbodyRow);
      wrapperTable.appendChild(tbody);
      slidesContainer.appendChild(wrapperTable);

      // ============================================
      // 3. ELIMINĂ ELEMENTELE UI DIN CLONE
      // ============================================
      const selectorsToRemove = [
        '.print-btn', '.email-btn', '.action-buttons-row',
        '.email-form-container', '.print-pdf', '.print-buttons',
        '.loading-overlay', '.spinner', '.nz-message',
        '.cdk-overlay-container', '.ant-message',
        '.scroll-to-top', '.back-to-top', '.no-print',
        '.logo-icon', 'nz-message-container', '.ant-notification',
        '.ant-back-top', '.print-only-header'
      ];

      selectorsToRemove.forEach(selector => {
        slidesContainer.querySelectorAll(selector).forEach(el => el.remove());
      });

      // ============================================
      // 4. CONVERTEȘTE IMAGINI LA URL ABSOLUTE
      // ============================================
      slidesContainer.querySelectorAll('img').forEach((img: HTMLImageElement) => {
        const src = img.getAttribute('src');
        if (src && !src.startsWith('data:') && !src.startsWith('http')) {
          img.setAttribute('src', new URL(src, window.location.origin).href);
        }
      });

      // ============================================
      // 4.1 FORȚEAZĂ FONT PE TOT CONȚINUTUL DINAMIC
      // ============================================
      const pdfFont = "'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif";

      // Elimină <style> tags din conținutul slide-urilor
      slidesContainer.querySelectorAll('style').forEach(el => el.remove());

      // Înlocuiește <font> tags cu <span>
      slidesContainer.querySelectorAll('font').forEach(el => {
        const span = document.createElement('span');
        span.innerHTML = el.innerHTML;
        el.replaceWith(span);
      });

      // Forțează fontul pe toate elementele text
      slidesContainer.querySelectorAll('p, span, div, li, ul, ol, h1, h2, h3, h4, h5, h6, td, th, tr, table, strong, em, b, i, a, label, blockquote, caption, figcaption, pre, code').forEach((el: HTMLElement) => {
        el.style.setProperty('font-family', pdfFont, 'important');
        el.style.removeProperty('font');
      });

      // ============================================
      // 5. CAPTUREAZĂ CSS (FĂRĂ @media print, mobile, și @font-face)
      // ============================================
      let capturedStyles = '';

      for (const sheet of Array.from(document.styleSheets)) {
        try {
          for (const rule of Array.from(sheet.cssRules)) {
            if (rule instanceof CSSMediaRule && rule.conditionText === 'print') {
              continue;
            }
            if (rule instanceof CSSMediaRule && rule.conditionText.includes('max-width')) {
              continue;
            }
            if (rule instanceof CSSFontFaceRule) {
              continue;
            }
            capturedStyles += rule.cssText + '\n';
          }
        } catch (e) {
          // Cross-origin
        }
      }

      // Strip ALL font-family declarations from captured styles
      capturedStyles = capturedStyles.replace(/font-family\s*:[^;}]+;?/gi, '');

      // ============================================
      // 6. STILURI PDF - PĂSTREAZĂ TOATE STILURILE ORIGINALE
      // ============================================
      const pdfStyles = `
      /* ========== @PAGE SETUP ========== */
      @page {
        size: A4;
        margin: 10mm 10mm 12mm 10mm;
      }

      /* ========== RESET & BASE ========== */
      * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        box-sizing: border-box !important;
      }

      html {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        background: white !important;
      }

      body {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        background: white !important;
        font-family: 'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif !important;
        font-size: 19px !important;
        line-height: 1.5 !important;
        color: #333 !important;
      }

      /* ========== ASCUNDE UI ========== */
      header, nav, footer,
      .ant-layout-header, .ant-layout-footer,
      .print-btn, .email-btn, .action-buttons-row,
      .email-form-container, .print-pdf, .print-buttons,
      .no-print, .logo-icon, .ant-back-top,
      .print-only-header {
        display: none !important;
      }

      /* ========== TABLE PENTRU REPEATING HEADER PE FIECARE PAGINĂ ========== */
      .pdf-page-table {
        width: 100% !important;
        border-collapse: collapse !important;
        border-spacing: 0 !important;
      }

      .pdf-page-table thead {
        display: table-header-group !important; /* Se repetă pe fiecare pagină */
      }

      .pdf-repeating-header {
        padding: 10px 20px 25px 20px !important;
        text-align: left !important;
        background: white !important;
        border-bottom: 2px solid #28b5b5 !important;
        font-weight: normal !important;
      }

      .pdf-header-logo {
        height: 54px !important;
        width: auto !important;
        display: block !important;
      }

      .pdf-content-cell {
        padding: 0 !important;
        vertical-align: top !important;
      }

      /* ========== CONTAINER SLIDES ========== */
      .pdf-slides-container {
        width: 100% !important;
      }

      /* ========== SLIDE WRAPPER - FĂRĂ PAGE BREAK FORȚAT ========== */
      .pdf-slide-wrapper {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        width: 100% !important;
        padding: 20px 20px 0 20px !important;
        margin: 0 !important;
        background: white !important;
      }

      /* ========== SECȚIUNI PRINCIPALE - PAGE BREAK ÎNAINTE ========== */
      .pdf-slide-wrapper.section-start {
        page-break-before: always !important;
        break-before: page !important;
      }

      /* Prima pagină fără break before (cuprins-ul) */
      .pdf-slide-wrapper:first-child {
        page-break-before: auto !important;
        break-before: auto !important;
      }

      /* ========== SLIDE CONTENT ========== */
      .pdf-slide-content {
        padding: 0 !important;
      }

      /* ========== SLIDES ========== */
      [id^="slide_"], .slides {
        width: 100% !important;
        padding: 8px 0 !important;
        margin: 0 !important;
      }
      
      /* ========== NG-ZORRO GRID - FORȚAT DESKTOP ========== */
      [nz-row], .ant-row {
        display: flex !important;
        flex-flow: row wrap !important;
        width: 100% !important;
        margin: 0 !important;
      }
      
      [nz-col], .ant-col,
      [class*="ant-col-"] {
        position: relative !important;
        display: block !important;
        box-sizing: border-box !important;
      }
      
      /* Desktop column widths - IMPORTANT! */
      .ant-col-lg-24 { flex: 0 0 100% !important; max-width: 100% !important; }
      .ant-col-lg-22 { flex: 0 0 91.66666667% !important; max-width: 91.66666667% !important; }
      .ant-col-lg-20 { flex: 0 0 83.33333333% !important; max-width: 83.33333333% !important; }
      .ant-col-lg-18 { flex: 0 0 75% !important; max-width: 75% !important; }
      .ant-col-lg-16 { flex: 0 0 66.66666667% !important; max-width: 66.66666667% !important; }
      .ant-col-lg-14 { flex: 0 0 58.33333333% !important; max-width: 58.33333333% !important; }
      .ant-col-lg-12 { flex: 0 0 50% !important; max-width: 50% !important; }
      .ant-col-lg-10 { flex: 0 0 41.66666667% !important; max-width: 41.66666667% !important; }
      .ant-col-lg-8 { flex: 0 0 33.33333333% !important; max-width: 33.33333333% !important; }
      .ant-col-lg-6 { flex: 0 0 25% !important; max-width: 25% !important; }
      
      .ant-col-md-24 { flex: 0 0 100% !important; max-width: 100% !important; }
      .ant-col-md-12 { flex: 0 0 50% !important; max-width: 50% !important; }
      .ant-col-md-10 { flex: 0 0 41.66666667% !important; max-width: 41.66666667% !important; }
      .ant-col-md-14 { flex: 0 0 58.33333333% !important; max-width: 58.33333333% !important; }
      
      /* Override XS (mobile) - forțăm desktop */
      .ant-col-xs-24[class*="ant-col-lg-"],
      .ant-col-xs-24[class*="ant-col-md-"] {
        flex: unset !important;
        max-width: unset !important;
      }
      
      /* ========== ALIGN ITEMS CENTER ========== */
      .slides .ant-row,
      .ant-row {
        align-items: center !important;
      }
      
      /* ========== IMAGE BAR (PÂLNIA) ========== */
      .image-bar,
      [class*="image-bar"],
      .balance-image {
        text-align: center !important;
        padding: 10px !important;
      }
      
      .image-bar img,
      .balance-image img {
        max-width: 250px !important;
        height: auto !important;
        margin: 0 auto !important;
        display: block !important;
      }

      /* ========== TABLES ========== */
      .ant-table-wrapper {
        width: 100% !important;
        overflow-x: visible !important;
      }
      
      .ant-table {
        width: 100% !important;
      }
      
      .ant-table table {
        width: 100% !important;
        border-collapse: collapse !important;
      }
      
      .ant-table-thead > tr > th {
        background: #28b5b5 !important;
        color: white !important;
        font-weight: 600 !important;
        padding: 10px 8px !important;
        font-size: 19px !important;
      }

      .ant-table-tbody > tr > td {
        padding: 8px !important;
        font-size: 19px !important;
        border-bottom: 1px solid #e8e8e8 !important;
      }
      
      .ant-table-tbody > tr:nth-child(even) > td {
        background: #fafafa !important;
      }
      
      /* Expand icons - hide */
      .ant-table-row-expand-icon-cell,
      .ant-table-row-expand-icon {
        display: none !important;
        width: 0 !important;
        padding: 0 !important;
      }
      
      /* ========== KPI TABLE COLORS ========== */
      .kpi_table tbody td.green, td.green {
        background-color: #8fd9a8 !important;
        border-right: 5px solid #64b67f !important;
      }
      
      .kpi_table tbody td.yellow, td.yellow {
        background-color: #f9ee71 !important;
        border-right: 5px solid #d9c80a !important;
      }
      
      .kpi_table tbody td.red, td.red {
        background-color: #f037a5 !important;
        border-right: 5px solid #b6257c !important;
      }
      
      .kpi_table tbody td.grey, td.grey {
        background-color: #a1a1a1 !important;
        border-right: 5px solid #646464 !important;
      }

      /* ========== FORȚEAZĂ EXPANDAREA COLLAPSE PANELS ========== */
      /* Toate panourile collapse trebuie să fie vizibile în PDF */
      .ant-collapse-content {
        display: block !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        visibility: visible !important;
        opacity: 1 !important;
      }

      .ant-collapse-content-box {
        display: block !important;
        visibility: visible !important;
      }

      /* Ascunde iconițele de expand/collapse din PDF */
      .ant-collapse-arrow,
      .ant-collapse-header .anticon {
        display: none !important;
      }

      /* Reduce spacing în collapse panels */
      .ant-collapse,
      .ant-collapse-item {
        margin: 0 !important;
        padding: 0 !important;
      }

      .ant-collapse-header {
        padding: 8px 0 !important;
        margin: 0 !important;
      }

      .ant-collapse-content-box {
        padding: 8px 0 !important;
      }

      .tableChartCollapse {
        padding: 0 !important;
        margin: 0 !important;
      }

      .negative {
        color: #ff0067 !important;
      }
      
      .highlight td {
        background-color: #f2f2f2 !important;
        font-weight: 700 !important;
      }
      
      .lowlight td {
        background-color: #e1e1e1 !important;
        font-weight: 700 !important;
      }
      
      .totals_table .check > td {
        background-color: #D2E69C !important;
        font-weight: 700 !important;
      }
      
      .totals_table .total > td {
        font-weight: 700 !important;
        color: #4b8336 !important;
      }
      
      /* ========== NOTES / RECOMANDĂRI ========== */
      .notes, .slide .notes {
        background-color: #f8f9fa !important;
        color: #333 !important;
        padding: 10px !important;
        border-radius: 6px !important;
        border-left: 4px solid #28b5b5 !important;
        margin: 8px 0 !important;
      }
      
      .notes p, .notes li, .notes ul {
        color: #333 !important;
      }
      
      /* ========== SLIDE BACKGROUNDS - REMOVE MOV ========== */
      .slide > div {
        background: transparent !important;
        background-color: transparent !important;
      }
      
      .slide > div:before {
        display: none !important;
        content: none !important;
      }
      
      /* ========== TOP/BOTTOM HEADERS ========== */
      .top-header {
        background-color: #fff !important;
        padding: 30px 0 !important;
      }
      
      .top-header:before,
      .bottom-header:before {
        opacity: 0.1 !important;
      }
      
      .bottom-header {
        background-color: #f1f1f1 !important;
        padding: 15px 0 !important;
      }
      
      /* ========== TYPOGRAPHY - FONTURI MAI MARI ========== */
      h1 {
        font-size: 38px !important;
        font-weight: 800 !important;
        margin-bottom: 15px !important;
      }

      h2 {
        font-size: 34px !important;
        font-weight: 700 !important;
        margin-bottom: 12px !important;
      }

      h3 {
        font-size: 30px !important;
        font-weight: 700 !important;
        margin-bottom: 2px !important;
        line-height: 1.4 !important;
      }

      .p-title,
      h3.p-title,
      .top-header h3.p-lg {
        padding-bottom: 0.5rem !important;
        margin-bottom: 1.5rem !important;
      }

      .p-title:after,
      .kpi-line:after {
        bottom: 0 !important;
      }

      .p-content h3 {
        margin-bottom: 18px !important;
        line-height: 1.5 !important;
      }

      h4 {
        font-size: 24px !important;
        font-weight: 600 !important;
        margin-bottom: 8px !important;
      }

      p {
        font-size: 19px !important;
        margin-bottom: 10px !important;
        line-height: 1.6 !important;
      }

      /* Cuprins chapter titles - larger font */
      .pdf-slide-wrapper:first-child p {
        font-size: 24px !important;
        font-weight: 700 !important;
      }

      li {
        font-size: 18px !important;
        line-height: 1.6 !important;
      }
      
      /* ========== TITLE CONTENT (2 COLUMNS) ========== */
      .title-content {
        display: flex !important;
        flex-direction: row !important;
        gap: 20px !important;
      }
      
      .title-content > div {
        flex: 1 !important;
        width: auto !important;
      }
      
      /* ========== QUOTE CARDS ========== */
      ul.title-content.footer-quotes-cards {
        display: flex !important;
        flex-direction: row !important;
        gap: 20px !important;
        list-style: none !important;
        padding: 0 !important;
      }
      
      ul.title-content.footer-quotes-cards > li {
        flex: 1 !important;
        max-width: 50% !important;
      }
      
      /* ========== REPORT INFO (CAPITOLE) ========== */
      .report-info {
        border-radius: 25px !important;
        padding: 10px 20px !important;
        margin: 15px 0 !important;
      }
      
      .report-info div {
        padding: 8px !important;
        font-size: 18px !important;
      }
      
      /* ========== PAGE BREAKS ========== */
      @page {
        size: A4;
        margin: 15mm 10mm;
      }
      
      table {
        page-break-inside: avoid !important;
      }
      
      h1, h2, h3, h4 {
        page-break-after: avoid !important;
      }
      
      img {
        page-break-inside: avoid !important;
      }
    `;

      // ============================================
      // 7. CONSTRUIEȘTE HTML
      // ============================================
      const slidesHtml = slidesContainer.outerHTML;

      const htmlContent = `
<!DOCTYPE html>
<html lang="ro">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=1200">
  <base href="${window.location.origin}/">
  <title>Raport Financiar - Doctor Business</title>
  <style>
    ${capturedStyles}
  </style>

  <style>
    ${pdfStyles}
  </style>
</head>
<body>
  ${slidesHtml}
  <style>
    *, *::before, *::after { font-family: 'Liberation Sans', 'DejaVu Sans', Arial, Helvetica, sans-serif !important; }
  </style>
</body>
</html>
      `.trim();

      console.log(`HTML generat: ${(htmlContent.length / 1024).toFixed(1)} KB`);
      console.log(`Total slide-uri cu logo: ${allSlides.length}`);

      // ============================================
      // 8. LOADING & SEND
      // ============================================
      this.message.loading('Se trimite raportul... Vă rugăm așteptați.', { nzDuration: 0 });

      const formData = new FormData();
      formData.append('email', this.recipientEmail.trim());
      formData.append('html_content', htmlContent);

      await this.http.post(this.apiUrl + '/send-report-email', formData).toPromise();

      this.message.remove();
      this.message.success('Raportul a fost trimis cu succes!');
      this.showEmailForm = false;
      this.recipientEmail = '';

    } catch (error: any) {
      console.error('Eroare:', error);
      this.message.remove();
      this.message.error(error?.error?.message || 'Eroare la trimiterea email-ului.');
    } finally {
      // Restaurează starea originală a panourilor
      this.allPanelsExpanded = previousAllPanelsExpanded;
      this.kpiPanelExpanded = previousKpiPanelExpanded;
      this.sendingEmail = false;
    }
  }

  /**
   * Toggle afișare formular notițe
   */
  toggleNotesForm(): void {
    this.showNotesForm = !this.showNotesForm;
  }

  /**
   * Încarcă notițele fișierului din baza de date
   */
  loadFileNotes(): void {
    const fileId = localStorage.getItem("fileId");
    console.log("loadFileNotes called - fileId:", fileId);

    if (!fileId) {
      console.log("No fileId in localStorage, skipping notes load");
      return;
    }

    this.http.get<any>(this.apiUrl + "/file/notes/" + fileId, {
      observe: "response",
    }).subscribe({
      next: (res: any) => {
        console.log("Notes loaded from API:", res.body);
        if (res.body && res.body.notes !== undefined) {
          this.fileNotes = res.body.notes || '';
        } else if (typeof res.body === 'string') {
          this.fileNotes = res.body;
        }
      },
      error: (err) => {
        console.error('Error loading file notes:', err);
        // If GET endpoint doesn't exist, notes will just start empty
        this.fileNotes = '';
      }
    });
  }

  /**
   * Salvează notițele fișierului
   */
  saveFileNotes(): void {
    // Always get the latest file ID from localStorage
    const fileId = localStorage.getItem("fileId");
    console.log("saveFileNotes called - fileId from localStorage:", fileId);

    if (!fileId) {
      this.message.error('ID-ul fișierului nu a fost găsit');
      return;
    }

    this.savingNotes = true;
    const noteData = { notes: this.fileNotes };
    const loadingMsgId = this.message.loading('Se salvează notițele...', { nzDuration: 0 }).messageId;

    this.http.put(this.apiUrl + "/file/notes/" + fileId, noteData, {
      observe: "response",
    }).subscribe({
      next: (res: any) => {
        this.message.remove(loadingMsgId);
        this.message.success('Notițele au fost salvate cu succes!');
        this.showNotesForm = false;
        this.savingNotes = false;
      },
      error: (err) => {
        console.error('Error saving notes:', err);
        this.message.remove(loadingMsgId);
        this.message.error('Eroare la salvarea notițelor');
        this.savingNotes = false;
      }
    });
  }


}
